import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
import { InterestProvider } from './context/InterestContext';

ReactDOM.createRoot(document.getElementById("root")).render(
  <InterestProvider>
    <App />
  </InterestProvider>
);